import { AppConstants, ServerConstants, ServiceConstants } from '../constants';
import store from 'config/redux/index';
import { end, start } from 'config/redux/slice';
import { ServiceModel } from 'models';
import { handleErrorWithTokenRenewal } from './common';
import { APIKit } from 'config/axios';
import { CardResponse, ICardRequestUpdate, LoginResponse, RequestVerifyForm } from 'types';
import { AppUtils, StorageUtils } from 'utils';

const {
  STORAGE_ACCESS_TOKEN,
  STORAGE_VALID_TO,
} = AppConstants;
const { API_V1_WEB_CARD } = ServerConstants;
const {
  REQUEST_CARD_OPTIONS_ID,
  REQUEST_CARD_UNREQUESTED_ID,
  REQUEST_CARD_CREATE_ID,
  REQUEST_CARD_REQUEST_ID,
  REQUEST_CARD_MULTIPLE_UPDATE_ID,
  REQUEST_CARD_SUBMIT_ID,
  REQUEST_CARD_VERIFY_ID,
} = ServiceConstants;

export async function cardOptions() {
  const requestId = REQUEST_CARD_OPTIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CARD}/options`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardOptions, [], requestId);
  }
}

export async function getUnrequested() {
  const requestId = REQUEST_CARD_UNREQUESTED_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CARD}/unrequested`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getUnrequested, [], requestId);
  }
}

export async function getRequest(cid: string) {
  const requestId = REQUEST_CARD_REQUEST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_WEB_CARD}/${cid}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getRequest, [cid], requestId);
  }
}

export async function createRequest(data: CardResponse) {
  const requestId = REQUEST_CARD_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_WEB_CARD, { ...data, source: 'WEB' });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, createRequest, [data], requestId);
  }
}

export async function updateRequestMultiple(cid: string, data: ICardRequestUpdate[]) {
  const requestId = REQUEST_CARD_MULTIPLE_UPDATE_ID;
  try {
    store.dispatch(start(requestId));
    data.forEach(el => {
      let val = data[el.name as any];
        if (val) {
          data[el.name as any] = AppUtils.convertToAppropriateValue(el.value);
        }
    });
    const response = await APIKit.patch(`${API_V1_WEB_CARD}/${cid}`, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, updateRequestMultiple, [cid, data], requestId);
  }
}

export async function submitRequest(cid: string) {
  const requestId = REQUEST_CARD_SUBMIT_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_WEB_CARD}/${cid}/request`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, submitRequest, [cid], requestId);
  }
}

export async function verify(data: RequestVerifyForm) {
  const requestId = REQUEST_CARD_VERIFY_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_WEB_CARD}/verify`, { ...data });
    const loginData: LoginResponse = response.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, loginData.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, loginData.validTo);
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, verify, [data], requestId);
  }
}